var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoEmployees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2319 10.5435C10.2319 12.3062 9.729 13.6562 8.72314 14.5938C7.72217 15.5312 6.27441 16 4.37988 16H1.34766V5.29199H4.70947C6.45752 5.29199 7.81494 5.75342 8.78174 6.67627C9.74854 7.59912 10.2319 8.88818 10.2319 10.5435ZM7.87354 10.6021C7.87354 8.30225 6.85791 7.15234 4.82666 7.15234H3.61816V14.125H4.59229C6.77979 14.125 7.87354 12.9507 7.87354 10.6021ZM19.1309 10.646C19.1309 12.5161 18.8232 13.9004 18.208 14.7988C17.5977 15.6973 16.6553 16.1465 15.3809 16.1465C14.1455 16.1465 13.2129 15.6826 12.583 14.7549C11.958 13.8271 11.6455 12.4575 11.6455 10.646C11.6455 8.75635 11.9507 7.36475 12.561 6.47119C13.1714 5.57275 14.1113 5.12354 15.3809 5.12354C16.6162 5.12354 17.5488 5.59229 18.1787 6.52979C18.8135 7.46729 19.1309 8.83936 19.1309 10.646ZM13.894 10.646C13.894 11.9595 14.0063 12.9019 14.231 13.4731C14.4604 14.0396 14.8438 14.3228 15.3809 14.3228C15.9082 14.3228 16.2891 14.0347 16.5234 13.4585C16.7578 12.8823 16.875 11.9448 16.875 10.646C16.875 9.33252 16.7554 8.39014 16.5161 7.81885C16.2817 7.24268 15.9033 6.95459 15.3809 6.95459C14.8486 6.95459 14.4678 7.24268 14.2383 7.81885C14.0088 8.39014 13.894 9.33252 13.894 10.646Z",
    fill: "#FF3225"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEmployees);
export default __webpack_public_path__ + "static/media/no-employees.4e37a45aa2ffee12142936368e208e4e.svg";
export { ForwardRef as ReactComponent };